import store from '@/store';
import { network } from './network';
import { getBaseInviteCode } from '@/utils/util';

export async function report(opts) {
	let inviteCode = store.state.user.inviteCode;
	const { VUE_APP_ENVIRONMENT } = window.APP_ENV;

	if (VUE_APP_ENVIRONMENT !== 'online') {
		return;
	}

	if (!inviteCode) {
		inviteCode = getBaseInviteCode();
	}

	const res = await network({
		url: 'https://report.arvessa.vip/api/data_report',
		method: 'post',
		params: {
			...opts,
			invite_code: inviteCode,
			extra_data: JSON.stringify({
				url: window.location.href
			})
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}